module.exports = __webpack_public_path__ + "static/img/hh-evidence.f8b18d16.png";